module.exports = __webpack_public_path__ + "static/img/gws_home_testimonials copy.098788f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws_home_testimonials copy.png
// module id = RaNT
// module chunks = 1